import _ from "lodash";
import * as api from "services/api";
import history from "../../../../history";

export const EDIT_CHART_OF_ACCOUNT =
  "[CHART_OF_ACCOUNT EDIT] EDIT_CHART_OF_ACCOUNT";
export const EDIT_CHART_OF_ACCOUNT_SUCCESS =
  "[CHART_OF_ACCOUNT EDIT] EDIT_CHART_OF_ACCOUNT_SUCCESS";
export const EDIT_CHART_OF_ACCOUNT_FAILED =
  "[CHART_OF_ACCOUNT EDIT] EDIT_CHART_OF_ACCOUNT_FAILED";

export const GET_CHART_OF_ACCOUNT =
  "[CHART_OF_ACCOUNT EDIT] GET_CHART_OF_ACCOUNT";
export const GET_CHART_OF_ACCOUNT_SUCCESS =
  "[CHART_OF_ACCOUNT EDIT] GET_CHART_OF_ACCOUNT_SUCCESS";
export const GET_CHART_OF_ACCOUNT_FAILED =
  "[CHART_OF_ACCOUNT EDIT] GET_CHART_OF_ACCOUNT_FAILED";

export const SET_VALUE = "[CHART_OF_ACCOUNT EDIT] SET_VALUE";
export const CLEAR_VALUE = "[CHART_OF_ACCOUNT EDIT] CLEAR_VALUE";

export function getChartOfAccount(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_CHART_OF_ACCOUNT
    });

    const { token } = getState().login;

    let response = await api.sendGet("/ChartOfAccounts/" + id, {
      Authorization: "Bearer " + token
    });

    if (response.ok) {
      let json = await response.json();

      let item = json.model;
      dispatch({
        type: GET_CHART_OF_ACCOUNT_SUCCESS,
        payload: item
      });
    } else {
      dispatch({ type: GET_CHART_OF_ACCOUNT_FAILED });
    }
  };
}

export function editChartOfAccount() {
  return async (dispatch, getState) => {
    dispatch({
      type: EDIT_CHART_OF_ACCOUNT
    });

    const { login, chartOfAccountEdit } = getState();

    let {
      name,
      code,
      description,
      chartOfAccountsType,
      item
    } = chartOfAccountEdit;

    const errors = {};

    if (!name) errors.name = "Informe um nome";

    dispatch(setValue({ errors }));

    if (_.keys(errors).length > 0)
      return dispatch({ type: EDIT_CHART_OF_ACCOUNT_FAILED });

    let response = await api.sendPut(
      "/ChartOfAccounts/" + item.id,
      {
        ...item,
        name,
        code,
        description,
        chartOfAccountsType
      },
      {
        Authorization: "Bearer " + login.token
      }
    );

    if (response.ok) {
      dispatch({
        type: EDIT_CHART_OF_ACCOUNT_SUCCESS
      });

      dispatch(clearValue());

      history.push("/ChartOfAccounts");
    } else {
      dispatch({ type: EDIT_CHART_OF_ACCOUNT_FAILED });
    }
  };
}

export function setValue(payload) {
  return {
    type: SET_VALUE,
    payload
  };
}

export function clearValue() {
  return {
    type: CLEAR_VALUE
  };
}
